module.exports = __webpack_public_path__ + "static/dabanga-3-7acd600ae72a8c699102c0469597f9c4.png";